import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_tv8s4823nu: FaireBrandEntity = {
  token: "b_tv8s4823nu",
  type: "brand",
  name: "FASHIONISTAAA",
  avatarUrl:
    "https://cdn.faire.com/fastly/8bcb22c36880a59abb5ef3744f57905c55c4758af5648696230601852258d78d.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/cc5b85177d71ace63f6a8daae0e6653580dd8d349d4321b915c71925866c2a03.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/8bcb22c36880a59abb5ef3744f57905c55c4758af5648696230601852258d78d.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/cc5b85177d71ace63f6a8daae0e6653580dd8d349d4321b915c71925866c2a03.jpeg",
  location: "brooklyn, NY, USA",
  minimumOrderDollars: 50,
  rating: 3.7,
  reviewCount: 37,
  isInsider: true,
  description:
    "Fashionistaa started out in 2015 as a small sterling silver jewelry wholesaler 3 yeas later we have crown to become 1 of the leading in Fine Jewelry and Gold Plated jewelry on the eastcoast we carry over 10,000 diffrent styles with large quantities of all out items and we would like to pass our savings on to out beloved customers.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:52:28.666Z",
    importedBy: "entity-db-cli",
  },
};
